import reducer from './reducer';
import operations from './operations';
import actions from './actions';

export {
    operations as userInfoOperations,
    actions as userInfoActions
};

export default reducer;
